import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import TextBlock from "@/components/TextBlock/TextBlock";
import { htmlify } from "@/services/utils";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxRiskConsiderationsPanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxRiskConsiderationsPanel: props } = dashboard;
	if (!props) {
		return null;
	}

	const { heading } = props;

	return (
		<ContentBlock
			id="fxRiskConsiderationsPanel"
			data-testid="FxRiskConsiderationsPanel"
			heading={htmlify(heading)}
			flex={flex}
			tabIndex={-1}
		>
			<TextBlock {...props} />
		</ContentBlock>
	);
};
